// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"148":"048d0f1a","281":"29a1bc90","297":"6cdf451c","367":"5916b491","434":"6ed8a22a","451":"b2e34e7c","453":"90c38bfe","674":"700a6635","811":"0671a058"}[chunkId] + ".chunk.js";
};